import React from "react";

interface ITableContentWrapperProps {
  headerIcon: React.ReactNode;
  headerTitle: string;
  children: React.ReactNode;
  showTopDivider?: boolean;
  subheaderTitle?: string;
  showSubheader?: boolean;
}

const TableContentWrapper: React.FC<ITableContentWrapperProps> = (props) => {
  return (
    <div className="bg-white">
      {props.showTopDivider && (
        <div className="mb-2 border-b border-gray-200" />
      )}
      <div className="flex items-center h-[32px] gap-2 mt-2">
        {props.headerIcon && <div className="text-xl">{props.headerIcon}</div>}
        <h2 className="font-sans font-semibold text-sm leading-normal tracking-normal text-[#737373]">
          {props.headerTitle}
        </h2>
      </div>
      {props.showSubheader && props.subheaderTitle && (
        <p className="font-sans font-medium text-xs mt-2 leading-[100%] tracking-[0%] text-[#737373]">
          {props.subheaderTitle}
        </p>
      )}
      <div className="mt-2">{props.children}</div>
    </div>
  );
};

export default TableContentWrapper;
